import { CouponType, OrderMethod, PaymentMethod, RefundReason } from '../../../../../../services/exports/Constants';

export default {
  title: 'Informații comandă',
  sections: {
    driver_info: 'Info șofer',
    order_info: 'Informații comandă',
    price_info: 'Informații preț',
    adjustments: 'Ajustări',
  },
  order_methods: {
    [OrderMethod.Pickup]: 'Ridicare',
    [OrderMethod.Delivery]: 'Livrare',
    [OrderMethod.OnSite]: 'Comandă la masă',
  },
  labels: {
    wolt_support: 'Număr telefon suport Wolt: {{phone_number}}',
    wolt_support_text:
      'Dacă aveți întrebări despre comandă, șofer sau probleme, contactați Wolt. Este important să menționați că este o comandă <strong>Wolt Drive</strong>',
    dummy_order: 'Comandă de test',
    asap: 'Imediat',
    driver_name: 'Numele șoferului',
    driver_phone_number: 'Telefon șofer',
    pin_code: 'PIN',
    dropoff_pin_code: 'PIN livrare',
    original: 'Original',
    delivery_fee: 'Taxă de livrare',
    tip: 'Bacșiș',
    service_fee: 'Procesare online',
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'Taxă PayPal',
    },
    promo_applied: {
      default: 'Promoție aplicată',
      [CouponType.Reward]: 'Puncte de loialitate aplicate',
      [CouponType.Cashback]: 'Puncte de loialitate aplicate',
      [CouponType.PromoCode]: 'Promoție aplicată',
      [CouponType.GiftCard]: 'Card cadou aplicat',
    },
    tax: 'Taxe',
    total: 'Total',
    online_payment: 'Clientul a plătit deja în aplicația {{provider}}',
    cash_payment: 'Plată la față locului',
    invoice_payment: 'Plată prin factură',
    old_order: 'Această comandă a fost finalizată cu succes',
    pickup_time: 'Ora ridicării',
    pickup_asap: 'Clientul a solicitat ridicarea cât mai rapidă posibil.',
    points_used: 'Această comandă include o recompensă cu puncte de loialitate utilizată de un client fidel',
    order_note: 'Notă comandă:',
    today: 'astăzi',
  },
  schedule: {
    header: 'Programată pentru {{date}}, {{time}}',
    text: 'Vă vom aminti când este momentul să începeți pregătirea comenzii',
  },
  adjustment_reasons: {
    [RefundReason.RequestedByCustomer]: 'Solicitat de client',
    [RefundReason.Reclamation]: 'Reclamație',
    [RefundReason.CommunicationError]: 'Eroare de comunicare',
    [RefundReason.Other]: 'Altele',
    [RefundReason.Dispute]: 'Dispută client',
    dispute_win: 'Dispută client câștigată',
    null: '',
  },
  toasts: {
    print_one: 'Se imprimă {{count}} bon: Comanda <strong>#{{orderNumber}}</strong>...',
    print_few: 'Se printează {{count}} bonuri: Comanda <strong>#{{orderNumber}}</strong>...',
    print_other: 'Se imprimă {{count}} bonuri: Comanda <strong>#{{orderNumber}}</strong>...',
    refund_successful: 'Rambursare reușită: Comanda <strong>#{{orderNumber}}</strong>...',
  },
  buttons: {
    print: 'Imprimă',
    confirm: 'Confirmă',
    reject: 'Respinge',
    refund: 'Rambursare',
  },
};
